import { render, staticRenderFns } from "./DonutChart54.vue?vue&type=template&id=7ab0ba60&scoped=true"
import script from "./DonutChart54.vue?vue&type=script&lang=js"
export * from "./DonutChart54.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab0ba60",
  null
  
)

export default component.exports